import { useEffect } from 'react';

import { trackerManager } from '@hero/clients';
import { TRACKER_EVENT } from '@hero/constants';
import { logoutAndRedirect } from '@hero/utils';

export default function SignOutPage() {
  const params = new URLSearchParams(window.location.search);
  const externalSource = params.get('externalSource');

  useEffect(() => {
    trackerManager.emit(TRACKER_EVENT.logout);

    logoutAndRedirect(externalSource);
  }, []);

  return null;
}
